<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Sipariş Tutarları</b-card-title>
      <div class="text-right">
        <b-card-sub-title class="mb-25">
          Yıllık Toplam Hak ediş
        </b-card-sub-title>
        <b-card-title>{{ priceFormat(totalAmmount) }}</b-card-title>
      </div>
      
    </b-card-header>
    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :height="400"
        :data="localData"
        :options="chartjsDataCopy"
        v-if="loadChart"
        ref="chart"
      />
      <b-card style="height:400px" v-else>
        <div class="loading">
          <div class="effect-1 effects"></div>
          <div class="effect-2 effects"></div>
          <div class="effect-3 effects"></div>
        </div>
      </b-card>
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardHeader,BDropdown, BDropdownItem, BCardBody,BCardSubTitle, BCardTitle } from 'bootstrap-vue';
import ChartjsComponentBarChart from '@components/charts-components/ChartjsComponentBarChart.vue';
import chartjsData from '@/components/charts-components/chartjsData'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BDropdown,
    BDropdownItem,
    BCardSubTitle,
    ChartjsComponentBarChart,
  },
  props: {
    inf_id: {
      type: Number,
    },
    chartData: {
      type: Object,
      default: () => ({}) // Varsayılan boş obje
    },
    loadChart:{
      type:Boolean,
      default: () => true
    }
  },
  data() {
    return {
      chartjsData,
      chartjsDataCopy: {}, // options kopyası
      localData: {}, // Grafik verisi
    };
  },
  methods: {
    updateChartOptions() {
      const maxTickValue = this.maxTickValue; 
      if(this.chartjsDataCopy.scales){

        const stepBase = 50; // Yuvarlama için temel değer
        const maxTicks = 10; // Maksimum 15 değer görünsün

        const stepSize = Math.ceil((this.maxTickValue / maxTicks) / stepBase) * stepBase;

      this.chartjsDataCopy.scales.yAxes[0].ticks = {
        stepSize: stepSize,
        min: 0,
        max: maxTickValue,
      };
    }
    },
    handleBarClick(event, elements) {
      if (elements.length > 0) {
        const elementIndex = elements[0]._index;

        // Varsayılan rengi güncelle
        this.localData.datasets[0].backgroundColor = this.localData.datasets[0].data.map((_, index) => {
          return index === elementIndex ? '#e8f541' : '#28dac6'; // Tıklanan öğeye kırmızı renk, diğerlerine varsayılan renk
        });

        // Veriyi yukarı iletme (isteğe bağlı)
        this.$emit('update-data', elementIndex);

        // Chart.js grafiğini yeniden render et
        this.chartjsDataCopy.animation = false; // Animasyonu devre dışı bırak
        this.$refs.chart.renderChart(this.localData, this.chartjsDataCopy);
      }
    }
  },
  computed: {
    totalAmmount() {
      if (this.localData.datasets) {
        return (
          this.localData.datasets[0].data.reduce((total, order) => total + order, 0)
        );
      } else {
        return 'Yükleniyor...';
      }
    },
    maxTickValue() {
      if (this.localData.datasets && this.localData.datasets[0].data.length > 0) {
        const maxDataValue = Math.max(...this.localData.datasets[0].data);
        return Math.ceil(maxDataValue * 1.2 / 50) * 50;
      }
      return 40; // Varsayılan bir değer
    },
  },
  mounted() {
    this.chartjsDataCopy = JSON.parse(JSON.stringify(this.chartjsData.latestBarChart.options));

    // Tooltip callback
    this.chartjsDataCopy.tooltips.callbacks = {
      label: function (tooltipItem) {
        return tooltipItem.value + ' TL';
      },
    };
    this.chartjsDataCopy.onClick = (event, elements) => this.handleBarClick(event, elements)
  },
  watch: {
    chartData: {
      immediate: true,
      deep: true,
      handler(newData) {
        this.localData = newData;
        this.updateChartOptions(); // Güncellenmiş `localData`'ya göre max değeri ayarla
      },
    },
    localData() {
      this.updateChartOptions(); // `localData` değişince grafiği güncelle
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
